import { _httpGet, _httpPost, type HttpGetOptions } from '@/service/index'

// 获取设备信息
export const getDefaultDeviceInfo = () => _httpGet('/api/app/device/getDefaultDeviceInfo')

// 获取设备功能列表
export const getFunctionList = (data: any = {}) => _httpGet('/api/app/functionList', data)

// 获取设备对话时长
export const getTalkTime = (data: any) => _httpGet('/api/app/talkTime', data)

// 获取实时位置
export const getRealtimeLocation = (data: any) =>
  _httpGet(`/api/v2/app/device/getRealtimeLocation`, data, {}, 20000)

// 获取js api key
export const getJsApiKey = () => _httpGet(`/api/app/getMapConfig`)

// 找回设备（设备响铃）
export const deviceRetrieval = (data: { deviceId: string }) =>
  _httpPost('/api/app/deviceRetrieval', data)

// 获取主账号所有的设备
export const getDeviceListByUserId = (options?: HttpGetOptions) =>
  _httpGet('/api/app/device/getDeviceListByUserId', {}, {}, undefined, options)

// 获取产品列表
export const getProductList = () => _httpGet('/api/app/productList')

// 根据设备ID获取设备信息
export const getDeviceInfoById = (deviceId: string) =>
  _httpGet('/api/app/device/getDeviceInfoById', { deviceId })

// 解绑设备
export const unbindUserDevice = (deviceId: string) =>
  _httpPost('/api/app/device/unbindUserDevice', { deviceId })

// 更新设备信息（设备名称）
export const updateDeviceInfo = (data: { deviceId: string; name: string }) =>
  _httpPost('/api/app/device/updateDevice', data)

// 获取所有子账号列表基础信息
export const getAllSubUser = (data?: any) =>
  _httpGet('/api/app/subuser/getAllSubUser', data)

// 切换设备绑定的子账号
export const changeBindUserDevice = (data: any) =>
  _httpPost('/api/app/device/changeBindUserDevice', data)

// 设置设备语速
export const setSpeechSpeed = (data: { deviceId: string; speechSpeedLevel: number }) =>
  _httpPost('/api/app/device/updateConfig', data)

// 设置设备音量
export const setDeviceVolume = (data: { deviceId: string; volume: number }) =>
  _httpPost('/api/app/device/updateConfig', { ...data, configType: 1 })

// 切换设备休眠状态
export const toggleDeviceSleep = (data: { deviceId: string }) =>
  _httpPost('/api/app/device/updateConfig', { ...data, configType: 2 })

// 获取设备配置选项
export const getDeviceConfigOptions = (data: { deviceId?: string }) =>
  _httpGet('/api/app/device/getConfigOptions', data)

// 切换当前设备
export const setCurrentDevice = (data: { deviceId: string; userId: string }) =>
  _httpPost('/api/app/device/setCurrentDevice', data)

// 配对码绑定设备
export const setBindUserDeviceCode = (data: any) =>
  _httpPost('/api/app/device/bindUserDevice', data)

// 获取当前设备绑定情况
export const getDeviceBindInfo = (data: any) =>
  _httpGet('/api/app/device/getDeviceBindInfo', data)
